import React, { useEffect, useState } from "react";
import BrandFlower from "../../assets/BrandFlower";
import { getImageUrl } from "../../utils/media";
import "./style.css";

export default function PageHero({
  imageUrl: imageProp,
  title,
  imageShape = "mask",
  className = "",
}) {
  const [configuredHeader, setConfiguredHeader] = useState(null);

  useEffect(() => {
    if (!title) return undefined;
    const pageKey = title
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "-");

    let active = true;
    fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3000"}/config/cabecalhos`)
      .then((response) => response.json())
      .then((headers) => {
        const header = headers.find((item) => item.pageKey === pageKey);
        if (active && header) setConfiguredHeader(header);
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, [title]);

  const imageUrl = getImageUrl(configuredHeader?.image) || getImageUrl(imageProp);
  const displayTitle = configuredHeader?.title || title;

  return (
    <section className={`page-hero ${className}`.trim()}>
      <div
        className={`page-hero__foto ${
          imageShape === "provided" ? "page-hero__foto--provided" : ""
        }`}
        style={
          imageUrl && imageShape !== "provided"
            ? { backgroundImage: `url(${imageUrl})` }
            : {}
        }
      >
        {imageUrl && imageShape === "provided" ? (
          <img src={imageUrl} alt="" aria-hidden="true" />
        ) : (
          !imageUrl && <div className="page-hero__foto-placeholder" />
        )}
      </div>

      <div className="page-hero__flor" aria-hidden="true">
        <BrandFlower
          petalColor="#3B5FA6"
          dropColor="#00ACEC"
          preserveAspectRatio="none"
        />
      </div>

      <h1 className="page-hero__titulo">{displayTitle}</h1>
    </section>
  );
}
